<nz-select *ngIf="projectOpt == 2" class="report-select" nzMode="tags" nzPlaceHolder="Please select" [(ngModel)]="value"
  (ngModelChange)="onChange($event)" name="projects" [nzAutoClearSearchValue] nzAllowClear
  [nzDropdownRender]="loadingTpl" nzMode="multiple">
  <nz-option nzCustomContent *ngFor="let item of main" [nzLabel]="item.code" [nzValue]="item.id">{{ item.code }} -
    {{ item.name }}
  </nz-option>
</nz-select>
<nz-select *ngIf="projectOpt == 3" class="report-select" nzMode="tags" nzPlaceHolder="Please select" [(ngModel)]="value"
  (ngModelChange)="onChange($event)" name="projects" nzAllowClear [nzDropdownRender]="loadingTpl" nzMode="multiple">
  <nz-option nzCustomContent *ngFor="let item of sub" [nzLabel]="item.code" [nzValue]="item.id">{{ item.code }} -
    {{ item.name }}
  </nz-option>
</nz-select>
<ng-template #loadingTpl>
  <nz-spin *ngIf="searching"></nz-spin>
  <nz-divider class="m-none"></nz-divider>
</ng-template>
